/**
 * NotificationService - Handles notification API operations
 */
export class NotificationService {
  constructor(apiClient) {
    this.apiClient = apiClient;
    console.log('NotificationService initialized');
  }

  /**
   * Fetch assigned summary containing document, consultation, and task counts
   * @returns {Promise<Object>} AssignedSummary with assignedDocumentsCount, userConsultationsCount, and assignedTasksCount
   */
  async fetchAssignedSummary() {
    return this.apiClient.get('/api/notification/assigned/fetch');
  }
}
